module.exports = __webpack_public_path__ + "img/check.20718664.png";